import {
  CartesianGrid,
  Label,
  Line,
  LineChart,
  ReferenceDot,
  ReferenceLine,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'

import CustomTooltip from '../Tooltip'

const LineGraph = ({
  data,
  dataKey,
  name,
  color,
  renderX = true,
  isTooltipVisible,
  handleMouseMove,
  activePayload,
  className
}) => {
  const onMouseMove = a => {
    handleMouseMove(a, dataKey)
  }
  return (
    <div className={className}>
      <LineChart
        width={850}
        height={160}
        data={data}
        onMouseMove={onMouseMove}
        margin={{ top: 5, right: 20, bottom: 5, left: 24 }}
        syncId="autoinviteChart"
      >
        <CartesianGrid stroke="#EBEBEB" horizontal={false} />
        <YAxis
          axisLine={false}
          width={70}
          tick={{
            fill: '#D1BFBF',
            fontSize: 12,
            transform: 'translate(-14, 0)'
          }}
          tickSize={0}
          padding={{ right: 30, left: 10, top: 44, bottom: 10 }}
        >
          <Label
            value={name}
            position="insideTopRight"
            fontSize="12"
            fontWeight="bold"
            offset={14}
            fill={color}
          />
        </YAxis>
        <XAxis
          hide={!renderX}
          axisLine={false}
          dataKey="dateView"
          tick={{
            fill: '#D1BFBF',
            fontSize: 12,
            transform: 'translate(0, 24)'
          }}
          tickSize={0}
          padding={{ bottom: 20 }}
        />
        {activePayload && (
          <ReferenceLine
            x={activePayload['dateView']}
            stroke="#B3C9FB"
            strokeWidth={1}
            isFront={true}
          />
        )}
        <Line
          type="linear"
          dot={false}
          dataKey={dataKey}
          stroke={color}
          strokeWidth={2}
        />
        <Tooltip
          content={<CustomTooltip dataKey={dataKey} isVisible={isTooltipVisible} />}
          cursor={false}
          isAnimationActive={false}
          coordinate={{ x: 0, y: -140 }}
          active={true}
          wrapperStyle={{
            visibility: 'visible'
          }}
        />
        {activePayload && (
          <ReferenceDot
            x={activePayload['dateView']}
            y={activePayload[dataKey]}
            r={7}
            fill="#FFFFFF"
            stroke={color}
            strokeWidth={2}
            ifOverflow="extendDomain"
          />
        )}
      </LineChart>
    </div>
  )
}

export default LineGraph
